<div
  fxLayout="row"
  fxLayoutAlign="space-between center"
  fxLayoutGap="10px"
>
  <div>
    <div *ngIf="statusPullData.sourceApi">
      <span>{{ 'dialog.authorization.source-api' | translate: { value: statusPullData.sourceApi | authorizationRuleAPIName | translate } }}</span>
    </div>

    <div *ngIf="statusPullData.createdBy">
      {{ 'dialog.authorization.created-by' | translate: { value: statusPullData.createdBy } }}
    </div>

    <div *ngIf="statusPullData.updatedBy">
      {{ 'dialog.authorization.updated-by' | translate: { value: statusPullData.updatedBy } }}
    </div>

    <div *ngIf="statusPullData.nextPullAt && statusPullData.canPullStatus">
      {{ 'dialog.authorization.next-pull-at' | translate: { value: statusPullData.nextPullAt | momentDateTime } }}
    </div>

    <div *ngIf="statusPullData.lastPulledAt">
      {{ 'dialog.authorization.last-pull-at' | translate: { value: statusPullData.lastPulledAt | momentDateTime } }}
      <ng-container *ngIf="statusPullData.lastPulledByName">
        {{ 'dialog.authorization.last-pull-by' | translate: { value: statusPullData.lastPulledByName } }}
      </ng-container>
    </div>

    <div *ngIf="!statusPullData.nextPullAt && !statusPullData.lastPulledAt">
      {{ 'dialog.authorization.no-pull-data' | translate }}
    </div>
  </div>
</div>
